// @ts-nocheck
import { FALLBACKLogo } from "./logos";
import { AssetInfoType } from "./types";
import { assetsPart1 } from "./assets-part1";
import { assetsPart2 } from "./assets-part2";

// The key eg. "ETH" MUST match the correct asset symbol returned from api
export const assets: AssetInfoType = {
  ...assetsPart1,
  ...assetsPart2,
};

export const getAssetInfo = (asset?: string) => {
  const info = asset ? assets[asset] : undefined;
  if (!info) {
    return {
      logo: FALLBACKLogo,
      name: asset,
      description: `${asset}`,
    };
  }
  return info;
};
